import Reveal from './Reveal';
import { useLanguage } from '../context/LanguageContext';

function ContactSection() {
  const { t } = useLanguage();

  return (
    <section id="contact" className="contact-section">
      <div className="contact-bg" />
      <div className="container contact-grid">
        <Reveal direction="left">
          <div className="contact-intro">
            <span className="eyebrow contact-eyebrow">{t.contact.eyebrow}</span>
            <h2>{t.contact.title}</h2>
            <p>{t.contact.subtitle}</p>
          </div>
        </Reveal>

        <div className="contact-cards">
          <Reveal direction="right" delay={80}>
            <a className="contact-card" href={`tel:${t.contact.phoneHref}`}>
              <span className="contact-card-label">{t.contact.phoneLabel}</span>
              <span className="contact-card-value" dir="ltr">
                {t.contact.phoneValue}
              </span>
              <span className="material-symbols-outlined contact-icon" aria-hidden="true">
                call
              </span>
            </a>
          </Reveal>
          <Reveal direction="right" delay={160}>
            <a className="contact-card" href={`mailto:${t.contact.emailValue}`}>
              <span className="contact-card-label">{t.contact.emailLabel}</span>
              <span className="contact-card-value" dir="ltr">
                {t.contact.emailValue}
              </span>
              <span className="material-symbols-outlined contact-icon" aria-hidden="true">
                mail
              </span>
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
